var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.636364,
    y: 0.636364,
    width: 26.7273,
    height: 26.7273,
    rx: 13.3636,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.636364,
    y: 0.636364,
    width: 26.7273,
    height: 26.7273,
    rx: 13.3636,
    stroke: "#1C74D0",
    strokeWidth: 1.27273
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 4C8.5 4 4 8.5 4 14C4 19.5 8.5 24 14 24C19.5 24 24 19.5 24 14C24 8.5 19.5 4 14 4ZM18.3 11.6L13.7 17.6C13.5 17.8 13.2 18 12.9 18C12.6 18 12.3 17.9 12.1 17.6L9.7 14.5C9.4 14.1 9.4 13.4 9.9 13.1C10.4 12.8 11 12.8 11.3 13.3L12.9 15.4L16.7 10.4C17 10 17.7 9.9 18.1 10.2C18.6 10.5 18.6 11.1 18.3 11.6Z",
    fill: "#1C74D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueTick);
export default __webpack_public_path__ + "static/media/blue-tick.d27367c01a326368cace7188ce7935f7.svg";
export { ForwardRef as ReactComponent };